module.exports = __webpack_public_path__ + "h5/img/dsh@3x.f2659f37.png";